// extracted by mini-css-extract-plugin
module.exports = {"textParagraph":"TextParagraph_textParagraph__mja_J"};